import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';
import { numberToPrettyString } from '@cian/utils';

function rangeFloorStr(gte?: number, lte?: number) {
  if (gte && lte) {
    return `${numberToPrettyString(gte)}-${numberToPrettyString(lte)} этаж`;
  }
  if (gte) {
    return `От ${numberToPrettyString(gte)} этажа`;
  }
  if (lte) {
    return `До ${numberToPrettyString(lte)} этажа`;
  }

  return 'Этаж';
}

export const floorInputDefinition = definitionFactory({
  key: 'floor',
  mapper: ({ gte, lte }) =>
    gte || lte
      ? [
          {
            label: rangeFloorStr(gte, lte),
            value: { gte, lte },
          },
        ]
      : [],
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'floor', options);
  },
});
